import React from "react";
import clsx from "clsx";

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const Card: React.FC<CardProps> = ({
  children,
  className,
  ...props
}) => {
  return (
    <div
      className={clsx(
        "bg-white dark:bg-zinc-900 rounded-xl shadow-sm border border-slate-200/60 dark:border-white/10 p-4 transition-all duration-200 hover:shadow-md",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};

interface CardBodyProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const CardBody: React.FC<CardBodyProps> = ({
  children,
  className,
  ...props
}) => {
  return (
    <div
      className={clsx(
        "mt-2 text-sm text-gray-700 dark:text-gray-300",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};
